module.exports = __webpack_public_path__ + "static/media/Brios-Cereales-Descripcion-Desktop.293d3544.webp";